import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DateUtil } from 'src/app/common/util';
import { ResponseObject } from 'src/app/models/response-object.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { AccountingReportService } from 'src/app/services/reports/accounting-report.service';
import { WarehouseService } from 'src/app/services/warehouse.service';

@Component({
  selector: 'app-budget-charts',
  templateUrl: './budget-charts.component.html',
  styleUrls: ['./budget-charts.component.scss']
})
export class BudgetChartsComponent implements OnInit {
  start: any = "";
  end: any = "";
  warehouse = null;
  warehouses: WarehouseResponse[] = [];

  constructor(
    private accountingReportService: AccountingReportService,
    private toastService: ToastrService,
    private warehouseService: WarehouseService
  ) {
    var today = new Date(DateUtil.getActualDate());
    this.end = DateUtil.getActualDate().split('T')[0];
    today.setDate(today.getDate() - 30);
    var other = new Date(today);
    var convert = DateUtil.parseDateToMilliseconds(other.toISOString());
    this.start = new Date(convert).toLocaleDateString('en-CA');
  }

  ngOnInit(): void {
    this.getWarehouses();
  }

  getWarehouses() {
    this.warehouseService.getWarehouseByClue('').subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

}
